export default __webpack_public_path__ + "static/byron_workbooks-ffbb4092b35fd2855410cdac83f84812.jpg";